/* 

Todo's 
- Implement dot's and controls for them
- Implement arrows and controls for them 
- Add preview in previewer
- Lazy load + lazy hydrate slider code
*/

let Swipeable = false

/* Client initialization */ 
export default async function createConverdySwipeable(el) {
  
  let settings = {}
  
  try {
    settings = JSON.parse(el.getAttribute('data-swipeable')) 
  } catch(e) {}

  const { swipeable } = settings

  if(swipeable.desktop !== true && swipeable.tablet && swipeable.mobile) {
    return 
  } 

  // debugger
  let instance = await create(el, settings, __CONVERDY__.breakpoint)

  // remove eventlistner
  document.addEventListener('breakpointChanged', ({detail}) => {
    
    if(instance) {
      destroy(instance, el)
    }

    window.setTimeout(async () => {
      instance = await create(el, settings, __CONVERDY__.breakpoint)
    })
  })

  return instance

}

export async function create(el, settings, breakpoint) {

  let cascadingSwipeable = cascadingValues(settings.swipeable)

  if(! cascadingSwipeable[breakpoint]) {
    return
  }

  if(! Swipeable) {
    Swipeable = (await import('./swipeable')).default
  }

  const swipeableGrid = el.firstElementChild

  let dotClickListner, arrowNextListner, arrowPrevListner;

  if(swipeableGrid.matches('.converdy-swipable')) {
    console.log('Already swipeable, destroy first')
    return false
  }
  
  const {spacing, swipeable, columns} = settings

  let dots = el.querySelectorAll(".sg-dot"),
      arrowLeft = el.querySelector(".sg-arrow--left"),
      arrowRight = el.querySelector(".sg-arrow--right");


  // Set height from grid
  swipeableGrid.style.setProperty('--swipeable-height', swipeableGrid.children[0].getBoundingClientRect().height + 'px')
  
  // Add swipeable classes
  swipeableGrid.classList.add('converdy-swipable');

  [...swipeableGrid.children].forEach(element => {
    element.classList.add('c_slide')
  })
  
  let {desktop: desktopColumns, tablet: tabletColumns, mobile: mobileColumns} =  cascadingValues(columns)
  let {desktop: desktopSpacing, tablet: tabletSpacing, mobile: mobileSpacing} = cascadingValues(spacing)

  return new Swipeable(swipeableGrid, {
    slidesPerView: desktopColumns,
    spacing: desktopSpacing,
    loop: true,
    breakpoints: {
      // Tablet
      "(max-width: 778px) and (min-width: 577px)": {
        slidesPerView: tabletColumns,
        spacing: tabletSpacing,
      },
      // Mobile
      "(max-width: 576px)": {
        slidesPerView: mobileColumns,
        spacing: mobileSpacing,
      }
    },
    created(instance) { 
      dotClickListner = function(e) {
        const index = [...e.target.parentElement.children].indexOf(e.target);
        instance.moveToSlide(index)
      }
      
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", dotClickListner)
      }) 

      arrowNextListner = function(e) {
        instance.next()
      }
      
      arrowPrevListner = function(e) {
        instance.prev()
      }

      if(arrowLeft) {
        arrowLeft.addEventListener("click", arrowPrevListner)
      }
      
      if(arrowRight) {
        arrowRight.addEventListener("click", arrowNextListner)
      }

      updateClasses(instance, dots, arrowLeft, arrowRight )

    },
    slideChanged(instance) {
      updateClasses(instance, dots, arrowLeft, arrowRight )
    },
    destroyed() {

      if(dots) {
        dots.forEach(function (dot, i) {
          dot.removeEventListener("click", dotClickListner)
        }) 
      }

      if(arrowLeft) {
        arrowLeft.removeEventListener("click", arrowPrevListner)
      }
      
      if(arrowRight) {
        arrowRight.removeEventListener("click", arrowNextListner)
      }

    }

  })
}

export function destroy(instance, el) {

  const swipeableGrid = el.firstElementChild
  let items = el.querySelectorAll('.c_slide')

  swipeableGrid.style.removeProperty('--swipeable-height')
  swipeableGrid.classList.remove('converdy-swipable')

  instance.destroy();

  // instance.destroy should cleanup inline styles, but it doesn't 
  items.forEach(item => {
    item.classList.remove('c_slide')
    item.removeAttribute('style')
  })
  
}

function updateClasses(instance, dots, arrowLeft, arrowRight) {

  const slide = instance.details().relativeSlide

  if(arrowLeft) {
    slide === 0
      ? arrowLeft.classList.add("sg-arrow--disabled")
      : arrowLeft.classList.remove("sg-arrow--disabled")
  }

  if(arrowRight) {
    slide === instance.details().size - 1
      ? arrowRight.classList.add("sg-arrow--disabled")
      : arrowRight.classList.remove("sg-arrow--disabled")
  }

  if(dots) {
    dots.forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("sg-dot--active")
        : dot.classList.remove("sg-dot--active")
    })
  }
}


/* 
@responsiveObj = {
  desktop: potentialValue,
  tablet: potentialValue
  mobile: potentialValue
}

Returns responsive object with cascading values from the provided object
*/

function cascadingValues(responsiveObj) {

  let desktop = responsiveObj.desktop
  let tablet = typeof responsiveObj.tablet !== 'undefined' ? responsiveObj.tablet : desktop
  let mobile = typeof responsiveObj.mobile !== 'undefined' ? responsiveObj.mobile : tablet

  return {
    desktop,
    tablet,
    mobile
  }

} 